import { render, staticRenderFns } from "./submission-type.vue?vue&type=template&id=08f3993d"
import script from "./submission-type.vue?vue&type=script&lang=js"
export * from "./submission-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports